// extracted by mini-css-extract-plugin
module.exports = {"modal":"modal--6ASha","body":"body--1y89z"};